import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Privacy from "./pages/Privacy";
import Legal from "./pages/Legal";
import AiProxyRedirect from "./pages/AiProxyRedirect";
import { Toaster } from "sonner";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/ai-proxy" element={<AiProxyRedirect />} />
        </Routes>

        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "rgba(19, 26, 45, 0.95)",
              color: "#FFFFFF",
              border: "1px solid rgba(0, 209, 255, 0.25)",
              backdropFilter: "blur(12px)",
              fontFamily: "Chivo, sans-serif",
            },
          }}
        />
      </div>
    </BrowserRouter>
  );
}

export default App;